import { getPlatformName, OPENSALUD360_PLATFORM_NAME, OPENSALUD_PLATFORM_NAME, PRIMESALUD_PLATFORM_NAME, OPENLEGAL_PLATFORM_NAME, ABOGALITYPRO_PLATFORM_NAME, UNIPROMEL_PLATFORM_NAME } from '@/constants/platformNames'

export const FOOTER_COMPONENT_NAMES = {
  OPENSALUD: 'FooterOpensalud',
  PRIMESALUD: 'FooterPrimesalud',
  OPENSALUD360: 'Footer360',
  OPENLEGAL: 'FooterOpenlegal',
  OPENLEGALHOME: 'FooterOpenlegalHome',
  ABOGALITYPRO: 'FooterAbogalityPro',
  UNIPROMEL: 'FooterUnipromel',
  OPENLEGAL360: 'FooterOpenlegal360'
}

export const footerHelpers = {
  getFooterComponentName () {
    const platformName = getPlatformName()
    switch (platformName) {
      case OPENSALUD360_PLATFORM_NAME:
        return FOOTER_COMPONENT_NAMES.OPENSALUD360
      case OPENSALUD_PLATFORM_NAME:
        return FOOTER_COMPONENT_NAMES.OPENSALUD
      case PRIMESALUD_PLATFORM_NAME:
        return FOOTER_COMPONENT_NAMES.PRIMESALUD
      case OPENLEGAL_PLATFORM_NAME:
        return FOOTER_COMPONENT_NAMES.OPENLEGALHOME
      case ABOGALITYPRO_PLATFORM_NAME:
        return FOOTER_COMPONENT_NAMES.ABOGALITYPRO
      case UNIPROMEL_PLATFORM_NAME:
        return FOOTER_COMPONENT_NAMES.UNIPROMEL
      default:
        return null
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/public/footers/index.js